export interface ButtonTextConfig {
  tooltipThumbUp: string;
  tooltipThumbDown: string;
  menuThumbUpTitle: string;
  menuThumbDownTitle: string;
  tooltipThumbUpCollaborator: string;
  tooltipThumbDownCollaborator: string;
}

export const DEFAULT_TEXTS = {
  tooltipThumbUp: 'Yes! Keep it going',
  tooltipThumbDown: 'No, thanks',
  menuThumbUpTitle: "Yes! Let's keep it going",
  menuThumbDownTitle: 'Not a match? Let us know why',
  tooltipThumbUpCollaborator: 'Only the hiring manager can advance',
  tooltipThumbDownCollaborator: 'Only the hiring manager can reject',
} as ButtonTextConfig;
